<script lang="ts">
    import { get_current_component, onMount } from 'svelte/internal'
    import { CompaniesRepository } from '../../../modules/usersApi/companies/companies.repository'
    import { CompaniesService } from '../../../modules/usersApi/companies/companies.service'
    import { Store } from '../../../modules/infra/store.service'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { createEventDispatcher, tick } from 'svelte'
    import SignupCompanyForm from './signup-company-form.svelte'
    const dispatch = createEventDispatcher()

    const compRep = new CompaniesRepository()
    const compS = new CompaniesService(compRep)
    const store = new Store()

    let show = false
    let needCreate = false
    let companies = []
    export let loaded = false
    export let auto = false

    onMount(async () => {
        try {
            show = true
            await loadCompanies()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    })

    async function loadCompanies() {
        try {
            loaded = false
            show = true
            companies = await compS.getAll()
            if (auto && companies.length === 1) {
                // 1 empresa. auto login
                selectCompany(companies[0].companyId)
                return
            }
            if (companies.length === 0) {
                needCreate = true
            }
            loaded = true
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function updateScreen() {
        companies = companies
    }

    async function selectCompany(companyId) {
        try {
            show = true
            const company = await compS.setCurrent(companyId)
            await tick()
            console.log('company selected', company)
            updateScreen()
            dispatch('success', company)
        } catch (error) {
            window.log('setCompany failed', 'debug', { error, context: 'company-select.svelte' })
            evaluateError(error)
            if (error === 'Token not allowed for this company.') {
                auto = false
                loaded = true
            }
            dispatch('error', error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }
</script>

{#if loaded}
    {#if needCreate}
        <SignupCompanyForm on:close={loadCompanies} />
    {:else}
        <div class="root">
            <div class="list">
                <div class="body">
                    {#each companies as item}
                        <div
                            class="line"
                            on:click={() => {
                                selectCompany(item.companyId)
                            }}
                        >
                            <div class="name">
                                {@html item.companyId === store.token?.companyId
                                    ? '<span class="color_yellow">' + item.companyName + '</span>'
                                    : item.companyName}
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
        </div>
    {/if}
{/if}
<LoadSpinner {show} />

<style>
    .root {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        user-select: none;
    }
    .list .body .line {
        display: flex;
        flex-grow: 1;
        border-top: 1px solid #99999933;
        padding: 8px 4px;
        align-items: center;
        cursor: pointer;
    }
    .list .body .line:first-child {
        border-top: 0px;
    }
    .list .body .line:hover {
        background-color: #66666630 !important;
    }
    .list .name {
        flex-grow: 1;
    }
    .act span {
        font-style: italic;
        opacity: 0.8;
    }
</style>
